export default "__VITE_ASSET__BGVkpjEi__"